import { IconMessages } from "@tabler/icons-react";
import styles from "./TalentMessages.module.css";

export default function MessagesHero({ total = 0, unread = 0, today = 0 }) {
  return (
    <div className={styles.msgHero}>
      <div className={styles.msgHeroText}>
        <div className={styles.msgHeroEyebrow}>
          <IconMessages size={14} /> Communication Hub
        </div>
        <div className={styles.msgHeroTitle}>Your Inbox</div>
        <div className={styles.msgHeroSub}>
          Manage conversations with clients and support in one place.
        </div>
      </div>
      <div className={styles.msgHeroStats}>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{total}</div>
          <div className={styles.heroStatLabel}>Total</div>
        </div>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{unread}</div>
          <div className={styles.heroStatLabel}>Unread</div>
        </div>
        <div className={styles.heroStat}>
          <div className={styles.heroStatValue}>{today}</div>
          <div className={styles.heroStatLabel}>Today</div>
        </div>
      </div>
    </div>
  );
}
